import * as React from "react";

/**
 * This is the entry in the list of DCFs that will be available to the user.
 */
export const MediaSerialItem = ({ recordId, isDisabled, onClick, correctionSelected }): JSX.Element => {
    return (
        <li
            className="col-md-6"
            style={{ paddingLeft: 5 + "px", paddingRight: 5 + "px" }}
            onClick={isDisabled ? null : onClick}>
            <input type="radio" name={`MediaSerial${recordId}`} value="true" checked={correctionSelected} readOnly disabled={isDisabled} />
            <label>
                <span className="posh-select-icon"><i className="fa fa-edit" aria-hidden="true"></i></span>
                <span className="posh-select-body">
                    <span className="posh-select-title">Change Card Serial Number</span>
                    <span className="posh-select-description text-muted">Change card serial number for a cough session</span>
                </span>
            </label>
        </li>
    );
}
